import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { API_CREATE_ITEM_SERVICE } from "api/item-services-managemnt";
import { API_UPDATE_ITEM_SERVICE } from "api/item-services-managemnt";
import { useLocation, useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";

const EditItemService = () => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false); // State for modal visibility
  const [valuesData, setValuesData] = useState(); // State for modal visibility
  const { t } = useTranslation();
  const location = useLocation();
  const Navigate = useNavigate();

  const dataItem = location.state && location.state.data;
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              name: dataItem?.name,
            }}
            validationSchema={Yup.object({
              name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(20, "Maximum character should be 20"),
            })}
            onSubmit={async (values, { setSubmitting, setFieldError }) => {
              try {
                // Open modal to confirm before updating
                setConfirmModalVisible(true);
                setValuesData(values);
                // let s = await API_UPDATE_ITEM_SERVICE(values, dataItem?._id);
                // Navigate("/admin/item-services/item-service-tables");

                // toast.success(s?.message);
              } catch (error) {
                console.error("error", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                <div>
                  <div
                    className="mb-8 flex cursor-pointer items-center gap-2"
                    onClick={() => {
                      Navigate(-1);
                    }}
                  >
                    <MdOutlineArrowBack
                      className="cursor-pointer"
                      style={{ fontSize: "17px" }}
                    />
                    <p>Back</p>
                  </div>
                  <Row gutter={[16, 16]}>
                    {/* Existing fields */}
                    <Col span={8}>
                      {/* Service Name */}
                      <div className="mb-3">
                        <label className="font-semibold">
                          {t("Service Name")}
                          <span className="text-[red]">*</span>
                        </label>
                        <Field
                          className="bg-transparent peer block  w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                          type="text"
                          name="name"
                          placeholder={t("Service Name")}
                          maxLength={20}
                          onKeyPress={(event) => {
                            const charCode = event.charCode;
                            if (
                              !(charCode >= 65 && charCode <= 90) && // A-Z
                              !(charCode >= 97 && charCode <= 122) && // a-z
                              charCode !== 32 // space
                            ) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-red-500"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[12rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting
                      ? t("Updating") + "..."
                      : t("Update Item Service")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          {/* Confirmation Modal */}
          <Modal
            visible={confirmModalVisible}
            onCancel={() => setConfirmModalVisible(false)}
            centered
          >
            <div
              className="flex items-center"
              style={{ flexDirection: "column" }}
            >
              <div>
                <p className="mb-1 font-bold">Save Changes</p>
                <p className="mb-8 font-medium">
                  Do you want to Save Changes before leaving the Page?
                </p>
              </div>
              <div className="flex gap-4">
                <button
                  className="linear text-black mt-2 w-full  rounded-xl py-[12px] text-base font-medium transition duration-200  dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => setConfirmModalVisible(false)}
                  style={{ width: "6rem" }}
                >
                  Cancel
                </button>
                <button
                  className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={async () => {
                    try {
                      // Open modal to confirm before updating
                      setConfirmModalVisible(true);
                      let s = await API_UPDATE_ITEM_SERVICE(
                        valuesData,
                        dataItem?._id
                      );
                      Navigate("/admin/item-services/item-service-tables");

                      toast.success(s?.message);
                    } catch (error) {
                      console.error("error", error);
                      toast.error(error?.response?.data?.message);
                    }
                  }}
                >
                  Save Changes
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default EditItemService;
